import { BUY_AUTOMATION_URLS, api_base_url } from "../../../constants";
import { getAppLocale } from "../../../utils/app-locale";
import { appConfiguration } from "../../../utils/app-starter";
import { API_INSTANCE } from "../../../utils/service-http";

export const checkBuyAutomationAccountExists = () => {

  const environment = process.env.REACT_APP_SEAMLESS_ENV || 'prod';
  const buyAutomationURL = BUY_AUTOMATION_URLS[environment]?.CHECK_ACCOUNT || BUY_AUTOMATION_URLS.prod.CHECK_ACCOUNT;

  let token = appConfiguration.seamlessToken;

  // Try to get the token from the getUserDetails (MySchneider only).
  if (window && window.getUserDetails && window.getUserDetails()?.access_token != null) {
    try {
      token = window.getUserDetails()?.access_token;
    }
    catch(error) {
      console.warn('Failed to retrieve token from user details function, using script token.');
    }
  }

  return API_INSTANCE.post(`${api_base_url}/check-buy-automation-account?locale=${getAppLocale()}`,
    {
      buyAutomationURL,
      token
    }).then((result) => {
      return result?.data?.payload;
    }).catch((error) => {
      throw error;
    });
}
